module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-22.30c1cd9e.png";